export enum ComponentType {
  SLIDER = "slider",
  INPUT = "input",
  DROPDOWN = "dropdown",
  GROUP = "group",
  MULTI_SELECT = "multiSelect",
  TAGS = "tags",
}

export interface Provider {
  base_url: string;
  name: string;
  client: string;
  workspace_id: number;
  id: number;
  // Distinct api_types available across this provider's models (e.g.
  // ["chat", "images", "video", "speech"]). Drives the API selector
  // and lets the model dropdown fetch models scoped to one (provider, api) pair.
  supported_apis?: string[];
}

export interface ModelCatalog {
  description: string | null;
  context_length: number | null;
  max_output_tokens: number | null;
  input_modalities: string[];
  output_modalities: string[];
  pricing_input_per_1m: number | null;
  pricing_output_per_1m: number | null;
  reasoning: boolean;
  knowledge_cutoff: string | null;
  latency: string | null;
  deprecation_date: string | null;
  retirement_date: string | null;
  supported_parameters: string[];
  requires_streaming?: boolean;
  disallows_streaming?: boolean;
}

export interface Model {
  created_at?: string;
  display_name: string | null;
  id: number;
  is_chat: boolean;
  is_internal: boolean;
  llm_model_name: string;
  params: Parameter[];
  provider_id: number;
  workspace_id: number;
  base_model?: string | null;
  api_type?: string | null;
  supported_apis?: string[];
  model_catalog?: ModelCatalog | null;
}

export interface Option {
  display_name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}

export interface ParameterBase {
  param_id: string;
  name: string;
  component_type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  default: any;
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  is_disabled?: boolean;
  is_json?: boolean;
  options?: Option[];
  required?: boolean;
  is_custom?: boolean;
  is_array?: boolean;
}

export interface DropdownParam extends ParameterBase {
  component_type: ComponentType.DROPDOWN;
  is_json?: boolean;
  options?: Option[];
}

export interface SliderParam extends ParameterBase {
  component_type: ComponentType.SLIDER;
  max?: number;
  min?: number;
  step?: number;
}

export interface InputParam extends ParameterBase {
  component_type: ComponentType.INPUT;
  max?: number;
  min?: number;
  is_int?: boolean;
}

export interface GroupParam extends ParameterBase {
  component_type: ComponentType.GROUP;
  parameters: Parameter[];
}

export interface MultiSelectParam extends ParameterBase {
  component_type: ComponentType.MULTI_SELECT;
  options: Option[];
  is_array: boolean;
  is_json?: boolean;
  default: string[];
}

export interface TagsParam extends ParameterBase {
  component_type: ComponentType.TAGS;
  value: string[];
  default: string[];
}

export type Parameter =
  | DropdownParam
  | SliderParam
  | InputParam
  | GroupParam
  | MultiSelectParam
  | TagsParam;
